module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "mode": _vm.edit,
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [(!_vm.isEdit) ? _c('v-btn', {
          on: {
            "click": function($event) {
              _vm.edit = !_vm.edit
            }
          }
        }, [_vm._v("Изменить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          on: {
            "click": _vm.upload
          }
        }, [_vm._v("Создать")]) : _vm._e(), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.isEdit) ? _c('v-flex', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName))])]), _vm._v(" "), _c('v-card-text', [_c('v-flex', [_vm._v("\n          Размещение: " + _vm._s(_vm.getDispalayPath(_vm.fileItem.path)) + "\n          ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n          Примечания: " + _vm._s(_vm.fileItem.desc) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName))])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Название",
      "hint": "Название папки",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.docName),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "docName", $$v)
      },
      expression: "fileItem.docName"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "Размещение в папке",
      "hint": "Структура папок видна только для пользователей депонента",
      "items": _vm.getDispalayPaths(),
      "item-value": "key",
      "item-text": "value"
    },
    model: {
      value: (_vm.fileItem.path),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "path", $$v)
      },
      expression: "fileItem.path"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Примечания",
      "rows": "3",
      "hint": "Примечания видны только для пользователей депонента",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.desc),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "desc", $$v)
      },
      expression: "fileItem.desc"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aba5b0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/depo/DocFolder.vue
// module id = 1175
// module chunks = 1